import { getDefaultMenu } from "./defaultMenu";
import { filterMenuByStrictAccess } from "./menuAccess";

export const getSidebarMenu = ({ menuAccess }) => {
  return filterMenuByStrictAccess(getDefaultMenu(), menuAccess);
};
